import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
 
const store = new Vuex.Store({
  // state: 用于保存共享数据
  state: {
    loginPop: false,
    sortList:[],
    timeList:[],
    searchList:[],
    typeList:[],
    config:{},
    xuzhi:{},
    withdraw:{},
    pcLink:'https://fanpdf.com/web/#/',
    userQrcode:''
  },
  // mutations: 用于保存修改共享数据的方法
  mutations: {
    mAdd(state){
      state.count = state.count + 1;
    },
    mSub(state){
      state.count = state.count - 1;
    },
    // 复制链接

  }
});
 
export default store;